import React from "react";

const UserAgreement = () => {
  return (
    <div className="min-h-screen">
      {/* Navbar */}
      <nav className="top-0 w-full z-10 shadow-lg"
      style={{ backgroundColor: "#212529" }}
      >
        <div className="container mx-auto flex justify-center items-center">
          {/* Logo */}
          <a href="#">
          <img src="images/surpeats-logo.svg" alt="Surpeats Logo" className="h-3/4" />          </a>
        </div>
      </nav>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-4">
  <h1 className="text-4xl font-bold text-gray-800 mb-4">User Agreement</h1>
  <h3 className="text-xl font-semibold text-gray-700 mb-6">Effective Date: 26th November 2024</h3>
  <p className="text-gray-700 mb-6">
    Welcome to Surpeats! By downloading, accessing, or using the Surpeats application or website
    (the "Platform"), you agree to comply with and be bound by this User Agreement (the
    "Agreement"). If you do not agree to these terms, please refrain from using the Platform.
  </p>

  <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Acceptance of Terms</h2>
  <p className="text-gray-700 mb-4">
    By using the Platform, you agree to these terms, our Privacy Policy, and any additional terms and
    conditions referenced or made available through the Platform. This Agreement constitutes a binding
    legal agreement between you and Surpeats.
  </p>

  <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Eligibility</h2>
  <p className="text-gray-700 mb-4">
    You must be at least 18 years old to use the Platform. By creating an account, you confirm that the
    information you provide is accurate and that you have the legal capacity to agree to this Agreement.
  </p>

  <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Platform Usage</h2>
  <p className="text-gray-700 mb-4">
    • The Platform connects users (“Customers”) with food providers (“Partners”) offering surplus food
    as “Mystery Bags” to reduce food waste.
    <br />• Mystery Bags are sold at discounted rates, and the contents are subject to availability and
    variation.
    <br />• Users agree to receive surplus food in an “as-is” condition and accept that no specific item
    or quantity is guaranteed.
  </p>

  <h2 className="text-2xl font-bold text-gray-800 mb-4">4. User Accounts</h2>
  <p className="text-gray-700 mb-4">
    • You must create an account to use the Platform. Keep your login details secure and notify us
    immediately of unauthorized access to your account.
    <br />• You are responsible for all activity on your account.
  </p>

  <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Order Placement and Payment</h2>
  <p className="text-gray-700 mb-4">
    • All orders are prepaid via the Platform using available payment methods.
    <br />• Payments are non-refundable unless Surpeats determines, at its sole discretion, otherwise.
  </p>

  <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Responsibilities of Users</h2>
  <p className="text-gray-700 mb-4">
    • Inspect food items upon receipt. While Partners strive to meet quality standards, Surpeats is not
    liable for any dissatisfaction regarding food quality.
    <br />• Follow proper food handling and storage practices to prevent waste.
  </p>

  <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Prohibited Activities</h2>
  <p className="text-gray-700 mb-4">
    You agree not to:
    <br />• Use the Platform for unlawful purposes.
    <br />• Post false, misleading, or offensive content.
    <br />• Attempt to hack, disrupt, or harm the Platform.
  </p>

  <h2 className="text-2xl font-bold text-gray-800 mb-4">8. Liability Disclaimer</h2>
  <p className="text-gray-700 mb-4">
    • The Platform is provided “as is.” Surpeats does not guarantee uninterrupted service or the
    availability of specific Partners or Mystery Bags.
    <br />• Surpeats is not responsible for food-related issues such as allergies or health concerns
    resulting from food consumption. Customers should address any concerns directly with Partners.
  </p>

  <h2 className="text-2xl font-bold text-gray-800 mb-4">9. Data Privacy</h2>
  <p className="text-gray-700 mb-4">
    Your use of the Platform is subject to our Privacy Policy, which explains how we collect, use, and
    protect your personal information.
  </p>

  <h2 className="text-2xl font-bold text-gray-800 mb-4">10. Termination</h2>
  <p className="text-gray-700 mb-4">
    Surpeats reserves the right to suspend or terminate accounts for violations of this Agreement or at
    its sole discretion.
  </p>

  <h2 className="text-2xl font-bold text-gray-800 mb-4">11. Amendments</h2>
  <p className="text-gray-700 mb-4">
    We may modify this Agreement from time to time. Changes will be effective when posted on the
    Platform. Continued use of the Platform constitutes acceptance of the updated terms.
  </p>

  <h2 className="text-2xl font-bold text-gray-800 mb-4">12. Governing Law</h2>
  <p className="text-gray-700 mb-4">
    This Agreement is governed by the laws of India. Disputes shall be resolved exclusively in courts
    located in [Your Jurisdiction].
  </p>

  <h2 className="text-2xl font-bold text-gray-800 mb-4">13. Contact Information</h2>
  <p className="text-gray-700 mb-4">
    For questions or concerns, please contact us at:
    <br />
    Email: admin@surpeats.com
  </p>
</div>


      {/* Footer */}
      <footer className="text-white py-8"
      style={{ backgroundColor: "#212529" }}
      >
        <div className="container mx-auto text-center">
          <div className="flex justify-center">
          <img src="images/surpeats-logo.svg" alt="Surpeats Logo" className="mx-auto h-32" />
          </div>
          <p>&copy; 2024 Surpeats. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default UserAgreement;
